import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=3aafde60&scoped=true"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"
import style0 from "./ContactItem.vue?vue&type=style&index=0&id=3aafde60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafde60",
  null
  
)

export default component.exports